import { FC } from 'react'
import styled from 'styled-components'
import { LandingPageSection } from '@/network/graphql.g'
import { Box, Flex } from '@/components/atoms/Grid'
import { H1 } from '@/components/atoms/typography'
import SummerSubCategories from '@/components/molecules/summer/subCategories'
import { validFor } from '@/theme/validFor'

type SummerCategoriesContainerProps = {
  position: string
  blackFridaySections: LandingPageSection[]
}

const SummerCategoriesContainer: FC<SummerCategoriesContainerProps> = ({
  position,
  blackFridaySections
}) => {
  const blackFridayCategory = blackFridaySections.find(
    (element) => element.position === position
  )
  const { name } = blackFridayCategory

  return (
    <Flex flexDirection="column" height={{ tablet: 'auto', desktop: '25%' }}>
      <TitleWrapper height={{ tablet: '20%', desktop: '20%' }}>
        <StyledH1 position={position}>{name}</StyledH1>
      </TitleWrapper>
      <Flex
        flexDirection={{
          mobile: 'column',
          tablet: 'row',
          desktop: 'column'
        }}
        height={{ tablet: '80%', desktop: '80%' }}
      >
        <Flex justifyContent="space-between" width="100%" height="100%">
          <SummerSubCategories
            blackFridayCategory={blackFridayCategory}
            position={position}
          />
        </Flex>
      </Flex>
    </Flex>
  )
}

export default SummerCategoriesContainer

const TitleWrapper = styled(Box)`
  text-align: center;
  margin: 65px 0 10px 0;
  ${validFor.tablet`
    margin: 40px 0 10px 0;
  `}
  ${validFor.mobile`
    margin: 35px 0 10px 0;
  `}
`
const StyledH1 = styled(H1)`
  font-size: 40px;
  letter-spacing: 3px;
  color: ${(props) => props.theme.colors.onBackground};
  ${validFor.mobile`
    font-size: 32px;
    line-height: 42px;
  `}
  ${validFor.tablet`
    font-size: 36px;
    line-height: 44px;
  `}
`
